import * as http from './http';
import ApiService from './service';
import { AuthTokenData, LoginCredentials } from '../models';

export default class UserService extends ApiService {
  loginEndPoint = '/v1/auth/login';
  forgotPasswordEndPoint = '/v1/auth/forgot-password';
  resetPasswordEndPoint = '/v1/auth/reset-password';
  usernameAlreadyExistsEndPoint = '/v1/admin-users/check-username-exists';
  emailAlreadyExistsEndPoint = '/v1/admin-users/check-email-exists';
  phoneAlreadyExistsEndPoint = '/v1/admin-users/check-phone-exists';

  public async login(data: LoginCredentials): Promise<AuthTokenData> {
    const url = `${this.apiDomain}${this.loginEndPoint}`;
    const response = await http.post<LoginCredentials, AuthTokenData>(
      url,
      data
    );
    return response.data;
  }
  public async forgotPassword(data: {
    username: string;
  }): Promise<{ userId: string }> {
    const url = `${this.apiDomain}${this.forgotPasswordEndPoint}`;
    const response = await http.post<{ username: string }, { userId: string }>(
      url,
      data
    );
    return response.data;
  }
  public async resetPassword(data: {
    otp: string;
    password: string;
    userId?: string;
  }): Promise<{ success: boolean }> {
    const url = `${this.apiDomain}${this.resetPasswordEndPoint}`;
    const response = await http.post<
      {
        otp: string;
        password: string;
        userId?: string;
      },
      { success: boolean }
    >(url, data);
    return response.data;
  }

  public async checkUsernameAlreadyExists(
    username: string,
    excludeUserId?: string
  ): Promise<boolean> {
    const url = `${this.apiDomain}${
      this.usernameAlreadyExistsEndPoint
    }?username=${encodeURIComponent(username)}${
      excludeUserId ? `&excludeUserId=${encodeURIComponent(excludeUserId)}` : ''
    }`;
    const response = await http.get<{ exists: boolean }>(url, this.token);
    return response.data.exists;
  }

  public async checkEmailAlreadyExists(
    email: string,
    excludeUserId?: string
  ): Promise<boolean> {
    const url = `${this.apiDomain}${
      this.emailAlreadyExistsEndPoint
    }?email=${encodeURIComponent(email)}${
      excludeUserId ? `&excludeUserId=${encodeURIComponent(excludeUserId)}` : ''
    }`;
    const response = await http.get<{ exists: boolean }>(url, this.token);
    return response.data.exists;
  }

  public async checkPhoneAlreadyExists(
    phone: string,
    excludeUserId?: string
  ): Promise<boolean> {
    const url = `${this.apiDomain}${
      this.phoneAlreadyExistsEndPoint
    }?phone=${encodeURIComponent(phone)}${
      excludeUserId ? `&excludeUserId=${encodeURIComponent(excludeUserId)}` : ''
    }`;
    const response = await http.get<{ exists: boolean }>(url, this.token);
    return response.data.exists;
  }
}
